'use strict';

window.jQuery = window.$ = require('jquery');

const processInclude = require('base/util');
require('core/components/spinner');

$(document).ready(function () {
  processInclude(require('./login'));
  processInclude(require('./common'));
  processInclude(require('./product/colorSwatches'));
  processInclude(require('./components/wishlist'));
  processInclude(require('tealium/tealiumEvents'));
});

require('base/thirdParty/bootstrap');
